module.exports = __webpack_public_path__ + "media/images/equipments-img-03-dc3aabb3f0af89f5898ac8ff97ea5c6e.jpg";